import { getAxiosClient } from "../axios-client";
import {
  GetAllOperatorClientsBody,
  GetAllOperatorClientsResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const getAllOperatorClients = async (
  body: GetAllOperatorClientsBody
) => {
  return await axiosClient.ax.post<GetAllOperatorClientsResponse>(
    "/Clients/GetAllClients",
    body
  );
};
